export default "https://a.travel-assets.com/partner-portal/image_bg.70f62ac93b3d.svg";